import { useModals } from 'almanac-ui/Modal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useCallback } from 'react'
import { useRootStore } from 'stores/RootStore'
import { ImagePickerDrawerV2 } from './ImagePickerDrawer/ImagePickerDrawerV2'
import { ImagePickerProviderProps } from './ImagePickerContextTypes'
import { Options } from 'stores/DrawersStore'
import { ModalProps } from 'almanac-ui/Modal/Types'
import { ImageMenuModal } from 'components/ImageMenu/ImageMenuModal/ImageMenuModal'
import { ImageMenuProps } from 'components/ImageMenu/Types'

interface MobileProps extends Omit<ImagePickerProviderProps, 'children'>, ModalProps {}
type DesktopProps = ImageMenuProps

export const useOpenImagePicker = () => {
  const { drawersStore } = useRootStore()
  const { isMobile } = useResponsiveDesign()
  const { openModal, closeModal } = useModals()

  const openImagePicker = useCallback(
    (mobileProps: MobileProps, desktopProps: DesktopProps, options: Options) => {
      if (isMobile) {
        return drawersStore.openDrawer(ImagePickerDrawerV2, mobileProps, options)
      }

      return openModal(ImageMenuModal, desktopProps, options)
    },
    [isMobile, drawersStore, openModal],
  )

  return {
    openImagePicker,
    closeImagePicker: isMobile ? drawersStore.closeDrawer : closeModal,
  }
}
